module.exports = __webpack_public_path__ + "static/media/wheel.8f7acd54.svg";